module.exports = __webpack_public_path__ + "1e9fa88e6e96922285153e116fdbc72e.png";